export namespace ServiceEnum {
  export enum Service {
    IMPORT_SOLD_TO = 201,
    /**
     * 'SAP推送有变化的产品数据给TPM，所有BU共用（增量）', '11'
     */
    IMPORT_PRODUCT = 202,
    /**
     * '从SAP导入送达方，及送达方与售达方关系信息(全量)', '10,11,12,13,14,15,16'
     */
    IMPORT_SHIP_TO = 203,
    /**
     * '从SAP导入供应商信息，所有BU共用(全量)', '11'
     */
    IMPORT_SUPPLIER = 205,
    /**
     * '从精准（奶粉）/SFA（液奶）导入门店信息(增量)', '11,14'
     */
    IMPORT_SHOP = 206,
    /**
     * '由SAP推送或从SAP导入销售信息(增量)，需再执行销量汇总、外部费用生成、自动标示发货完成、活动执行情况统计的任务', '10,11,12,13,14,15,16'
     */
    IMPORT_SELLIN = 208,
    /**
     * 'SAP推送有变化的产品定价数据给TPM，所有BU共用（增量）', '11'
     */
    IMPORT_PRODUCT_PRICE = 209,
    /**
     * '从精准（奶粉）/SFA（液奶）导入二级销售信息(增量)，含门店入库、售出（奶粉）、派发（奶粉）、扫码（奶粉）、新客', '11,14'
     */
    IMPORT_SELLOUT = 211,
    /**
     * '从单点登陆系统导入用户基本信息(增量)', '11'
     */
    IMPORT_USER_INFO = 212,
    /**
     * '从精准（奶粉）/SFA（液奶）导入门店任务的文字采集结果信息', '10,11,12,13,14,15,16'
     */
    IMPORT_SFA_RESULT = 213,

    /**
     * SAP实时推送订单状态到DMS
     */
    IMPORT_SO_STATUS = 214,

    /**
     * '将系统中的转账/账扣/第三方支付/票扣/转资金池的核销单导出SAP(增量)，折扣/指定货补/非指定货补的核销单导出费用池(增量)', '10,11,12,13,14,15,16'
     */
    EXPORT_PAYMENT = 301,
    /**
     * '将系统中的免费货活动导出DMS(增量)，此任务在审批完成时会自动执行', '10,11,12,13,14,15,16'
     */
    EXPORT_FREE_GOODS = 303,
    /**
     * '将系统中需要SFA采集的活动导出给精准（奶粉）/SFA（液奶）', '10,11,12,13,14,15,16'
     */
    EXPORT_ACTIVITY_TO_SFA = 305,
    /**
     * 会计凭证上账(SAP) <br/>
     * 11,12,13,14,15,16
     */
    EXPORT_ACCOUNTING_VOUCHER = 309,
    /**
     * '用于发送审批提醒邮件', '11'
     */
    EXEC_APPROVED_EMAIL = 401,
    /**
     * '生成活动结案、核销、关闭等提醒信息', '10,11,12,13,14,15,16'
     */
    EXEC_OPERATE_REMIND = 402,
    /**
     * '根据系统中当前的数据模拟预测当月和未来月的预提信息', '10,11,12,13,14,15,16'
     */
    EXEC_SIMULATION_ACCRUAL = 404,
    /**
     * '系统将自动关闭满足条件的活动单或返点单', '10,11,12,13,14,15,16'
     */
    EXEC_AUTO_CLOSE = 405,
    /**
     * '汇总一级、二级销量信息，用于相关统计功能', '10,11,12,13,14,15,16'
     */
    EXEC_SELL_SUMMARY = 406,
    /**
     * 模拟预提
     */
    EXEC_FORECAST_ACCRUAL = 407,
    /**
     * 模拟预提（广告）
     */
    EXEC_FORECAST_ACCRUAL_MKT = 408,
    /**
     * '用于统计活动相关的实际销量信息，以便计算出活动的预提金额等信息', '10,11,12,13,14,15,16'
     */
    EXEC_ACTIVITY_RESULT = 409,
    /**
     * '从销量信息中生成免费货、促销折扣或搭赠、合同折扣产生的费用，用于费用统计', '10,11,12,13,14,15,16'
     */
    EXEC_EXPENSE_NON_TPM = 410,
    /**
     * '系统运行所需的各种统计信息自动更新', '11'
     */
    EXEC_UPDATE_SUMMARY = 413,
    /**
     * '每月合同费用生成服务，请至合同管理中进行生成', '10,11,12,13,14,15,16'
     */
    EXEC_CONTRACT_REBATE = 412,
    /**
     * '每月合同费用生成服务，请至合同管理中进行生成', '10,11,12,13,14,15,16'
     */
    EXEC_POLICY_REBATE = 414,
    /**
     * '每月从精准导入君币费用', '10,11,12,13,14,15,16'
     */
    IMPORT_JUNBI = 415,
    /**
     * '每月合同费用生成服务，请至合同管理中进行生成', '11,12,13,16'
     */
    EXEC_FRIDGE = 416,
    /**
     * '经销商费用池对账每月初自动更新', '10,11,12,13,14,15,16'
     */
    EXEC_EXPENSE_MATCH = 417,
    /**
     * '用于从sap定时获取更新发货仓', '10,11,12,13,14,15,16'
     */
    IMPORT_WAREHOUSE = 418,
    /**
     * '从sap获取上月电子发票数据', '11,12,13,14,15,16'
     */
    IMPORT_INVOICE = 419,
    /**
     * '从sap获取订单状态', '11,12,13,14,15,16'
     */
    IMPORT_ORDER_STATUS = 420,
    /**
     * '将系统中待审批的单据导出到OA，显示单据链接，点击后回到TPM中做审批', '10,11,12,13,14,15,16'
     */
    EXPORT_WAITING_APPROVAL = 422,
    /**
     * '根据系统中当前的费用追加池明细数据进行预提计算，得出费用池的正式预提结果', '10,11,12,13,14,15,16'
     */
    EXEC_FORMAL_ACCRUAL_POOL = 423,

    /**
     * '模拟预提(费用池)', '10,11,12,13,14,15,16'
     */
    EXEC_FORECAST_ACCRUAL_POOL = 425,

    /**
     * '发货扣减费用池', '10,11,12,13,14,15,16'
     */
    EXEC_FOR_DELIVERY_TO_POOL = 426,

    /**
     * '费用池成本还原', '10,11,12,13,14,15,16'
     */
    EXEC_ACCRUAL_POOL_CONVERT = 427,

    /**
     * 将正式生成的费用池预提结果导出至ERP
     */
    EXPORT_FORMAL_ACCRUAL_POOL = 432,
    /**
     * 将正式生成的广告类预提结果导出至ERP
     */
    IMPORT_ACCRUAL_RESULT = 434,
    /**
     * 将正式生成的广告类预提结果导出至ERP
     */
    IMPORT_COMPANY_CREDENTIAL = 435,
    /**
     * TPM提供接口，星瀚调用此接口推送核销单明细的SAP凭证结果
     */
    IMPORT_SAP_VOUCHERS_GX = 436,
    /**
     * TPM提供接口，星瀚调用此接口推送作废的数据
     */
    IMPORT_MODIFY_SP_GX = 437,
    /**
     * 生成冲收入报告
     */
    EXEC_REVENUE_DEDUCT = 438,
    /**
     * 冲收入报告导出(SAP)
     */
    EXPORT_REVENUE_DEDUCT = 439,
    /**
     * 正式预提
     */
    EXEC_FORMAL_ACCRUAL = 503,
    /**
     * 正式预提（广告）
     */
    EXEC_FORMAL_ACCRUAL_MKT = 504,
    /**
     * 预提导出
     */
    EXPORT_FORMAL_ACCRUAL = 505,
    /**
     * 预提导出（广告）
     */
    EXPORT_FORMAL_ACCRUAL_MKT = 506,

  }
}
